export function readyApplications(catalog) {
  return Array.isArray(catalog?.applications)
    ? catalog.applications.filter((application) => application?.id && application?.entryPath)
    : []
}

export function adaptiveDestination({ user, catalog, context, requestedPath = '' }) {
  if (user?.mustChangePassword) return '/change-password'
  if (requestedPath && requestedPath !== '/' && requestedPath !== '/login') return requestedPath

  const applications = readyApplications(catalog)
  if (applications.length === 0 && catalog?.platformEntryPath) return catalog.platformEntryPath
  if (applications.length === 1) return applications[0].entryPath
  return applications.length > 1 ? '/apps' : '/no-access'
}

export function applicationById(catalog, id) {
  return readyApplications(catalog).find((application) => application.id === id) ?? null
}
